(() => {
  const tagName = 'fs-pdp-status';
  if (!window.customElements || customElements.get(tagName)) return;

  const rootSelector = 'product-info[data-fs-product-page]';
  const controllers = new WeakMap();

  function readState(marker) {
    const available = marker.getAttribute('data-available');
    const backorder = marker.getAttribute('data-backorder');
    const variantId = marker.getAttribute('data-variant-id') || '';
    if (available === 'false') return { delivery: 'unavailable', purchase: 'unavailable', variantId };
    if (available !== 'true' || !variantId || !['true', 'false'].includes(backorder)) {
      return { delivery: 'pending', purchase: 'pending', variantId };
    }
    return { delivery: backorder === 'true' ? 'backorder' : 'in-stock', purchase: 'available', variantId };
  }

  function setAttributeIfChanged(element, name, value) {
    if (element.getAttribute(name) !== value) element.setAttribute(name, value);
  }

  class StatusController {
    constructor(root) {
      this.root = root;
      this.markers = new Set();
      this.current = null;
      this.waitingForResponse = false;
      this.onChange = this.onChange.bind(this);
      root.addEventListener('change', this.onChange, true);
    }

    connect(marker) {
      this.markers.add(marker);
      this.current = marker;
      this.waitingForResponse = false;
      this.refresh();
    }

    disconnect(marker) {
      this.markers.delete(marker);
      if (this.current === marker) {
        this.current = null;
        if (this.root.isConnected) this.apply('pending', 'pending');
      }
      if (!this.markers.size) {
        this.root.removeEventListener('change', this.onChange, true);
        controllers.delete(this.root);
      }
    }

    ownedByRoot(element) {
      return element?.closest('product-info') === this.root;
    }

    onChange(event) {
      const target = event.target;
      if (!(target instanceof Element) || !this.ownedByRoot(target)) return;
      if (target.closest('variant-selects') && target.matches('select, input[type="radio"]')) {
        this.waitingForResponse = true;
        this.apply('pending', 'pending');
        return;
      }
      if (target.matches('product-form input[name="id"]')) this.refresh();
    }

    refresh() {
      if (!this.current || this.waitingForResponse) return;
      const state = readState(this.current);
      const input = Array.from(this.root.querySelectorAll('product-form input[name="id"]'))
        .find((candidate) => this.ownedByRoot(candidate));
      if (input && String(input.value) !== state.variantId) {
        this.apply('pending', 'pending');
        return;
      }
      this.apply(state.delivery, state.purchase);
    }

    apply(delivery, purchase) {
      setAttributeIfChanged(this.root, 'data-fs-delivery-state', delivery);
      setAttributeIfChanged(this.root, 'data-fs-purchase-state', purchase);
    }
  }

  customElements.define(tagName, class extends HTMLElement {
    connectedCallback() {
      const root = this.closest(rootSelector);
      if (!root || this.closest('product-info') !== root) return;
      let controller = controllers.get(root);
      if (!controller) {
        controller = new StatusController(root);
        controllers.set(root, controller);
      }
      this.statusController = controller;
      controller.connect(this);
    }

    disconnectedCallback() {
      this.statusController?.disconnect(this);
      this.statusController = null;
    }
  });
})();
